import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	brainstormingTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.brainstorming-name',
		defaultMessage: 'Brainstorming',
		description:
			'Title for brainstorming template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	brainstormingTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.brainstorming-description',
		defaultMessage: 'Generate and group ideas',
		description: 'Description for brainstorming template to explain what the template consist of',
	},
	businesStatusUpdateTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.business-status-update-name',
		defaultMessage: 'Business Status Update',
		description:
			'Title for business status update template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	businesStatusUpdateTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.business-status-update-description',
		defaultMessage: 'Share team-wide updates',
		description:
			'Description for business status update template to explain what the template consist of',
	},
	DACIDecisionDocumentTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.daci-decision-document-name',
		defaultMessage: 'DACI:Decision Document',
		description:
			'Title for DACI decision document template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	DACIDecisionDocumentTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.brainstorming-description',
		defaultMessage: 'Drive clarity on decisions',
		description:
			'Description for DACI decision document template to explain what the template consist of',
	},
	designDecisionTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.design-decision-name',
		defaultMessage: 'Design Decision',
		description:
			'Title for design decision template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	designDecisionTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.design-decision-description',
		defaultMessage: 'Document design outcomes',
		description: 'Description for design decision template to explain what the template consist of',
	},
	designSprintTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.design-sprint-name',
		defaultMessage: 'Design Sprint',
		description:
			'Title for design sprint template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	designSprintTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.design-sprint-description',
		defaultMessage: 'Run a structured sprint cycle',
		description: 'Description for design sprint template to explain what the template consist of',
	},
	employeeHandbookTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.employee-handbook-name',
		defaultMessage: 'Employee Handbook',
		description:
			'Title for employee handbook template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	employeeHandbookTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.employee-handbook-description',
		defaultMessage: 'Centralize company policies',
		description:
			'Description for employee handbook template to explain what the template consist of',
	},
	fundraisingDatabaseTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.fundraising-database-name',
		defaultMessage: 'Fundraising Database',
		description:
			'Title for fundraising database template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	fundraisingDatabaseTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.fundraising-database-description',
		defaultMessage: 'Track investor outreach',
		description:
			'Description for fundraising database template to explain what the template consist of',
	},
	hiringProcessTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.hiring-process-name',
		defaultMessage: 'Hiring Process',
		description:
			'Title for hiring process template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	hiringProcessTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.hiring-process-description',
		defaultMessage: 'Outline each hiring step',
		description: 'Description for hiring process template to explain what the template consist of',
	},
	ITSMRunbookTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.itsm-runbook-name',
		defaultMessage: 'ITSM Runbook',
		description:
			'Title for ITSM runbook template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	ITSMRunbookTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.itsm-runbook-description',
		defaultMessage: 'Standardize incident response',
		description: 'Description for ITSM runbook template to explain what the template consist of',
	},
	marketingCampaignTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-campaign-name',
		defaultMessage: 'Marketing Campaign',
		description:
			'Title for marketing campaign template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	marketingCampaignTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-campaign-description',
		defaultMessage: 'Plan campaign work',
		description:
			'Description for marketing campaign template to explain what the template consist of',
	},
	marketingPlanTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-plan-name',
		defaultMessage: 'Marketing Plan',
		description:
			'Title for marketing plan template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	marketingPlanTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-plan-description',
		defaultMessage: 'Outline marketing goals',
		description: 'Description for marketing plan template to explain what the template consist of',
	},
	meetingNotesTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.meeting-notes-name',
		defaultMessage: 'Meeting notes',
		description:
			'Title for meeting notes template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	meetingNotesTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.meeting-notes-description',
		defaultMessage: 'Capture meeting outcomes',
		description: 'Description for meeting notes template to explain what the template consist of',
	},
	productRequirementsTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.product-requirements-name',
		defaultMessage: 'Product Requirements',
		description:
			'Title for product requirements template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	productRequirementsTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.product-requirements-description',
		defaultMessage: 'Align product goals and scope',
		description:
			'Description for product requirements template to explain what the template consist of',
	},
	projectPlanTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.project-plan-name',
		defaultMessage: 'Project Plan',
		description:
			'Title for project plan template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	projectPlanTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.project-plan-description',
		defaultMessage: 'Align teams on project scope',
		description: 'Description for project plan template to explain what the template consist of',
	},
	projectStatusTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.project-status-report-name',
		defaultMessage: 'Project Status Report',
		description:
			'Title for project status report template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	projectStatusTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.project-status-report-description',
		defaultMessage: 'Share team status updates',
		description: 'Description for project status template to explain what the template consist of',
	},
	retrospectiveTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.retrospective-name',
		defaultMessage: 'Retrospective',
		description:
			'Title for retrospective template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	retrospectiveTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.retrospective-description',
		defaultMessage: 'Reflect and improve as a team',
		description: 'Description for retrospective template to explain what the template consist of',
	},
	salesAccountPlanningTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-account-planning-name',
		defaultMessage: 'Sales Account Planning',
		description:
			'Title for sales account planning template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	salesAccountPlanningTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-account-planning-description',
		defaultMessage: 'Set goals for key accounts',
		description:
			'Description for sales account planning template to explain what the template consist of',
	},
	salesPortalTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-portal-name',
		defaultMessage: 'Sales Portal',
		description:
			'Title for sales portal template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	salesPortalTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-portal-description',
		defaultMessage: 'Organize sales resources',
		description: 'Description for sales portal template to explain what the template consist of',
	},
	softwareArchitectureReviewTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.software-architecture-review-name',
		defaultMessage: 'Software Architecture Review',
		description:
			'Title for software architecture review template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	softwareArchitectureReviewTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.software-architecture-review-description',
		defaultMessage: 'Evaluate technical designs',
		description:
			'Description for software architecture reviewtemplate to explain what the template consist of',
	},
	standardOperatingProcedureTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.standard-operating-procedure-name',
		defaultMessage: 'Standard Operating Procedure',
		description:
			'Title for standard operating procedure template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	standardOperatingProcedureTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.standard-operating-procedure-description',
		defaultMessage: 'Document recurring steps',
		description:
			'Description for standard operating procedure template to explain what the template consist of',
	},
	troubleshootingArticleTemplateName: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.troubleshooting-article-name',
		defaultMessage: 'Troubleshooting article',
		description:
			'Title for troubleshooting article template. This text will appear in the templates shortcut in quick action panel for a blank page',
	},
	troubleshootingArticleTemplateDescription: {
		id: 'experiment-land-users-in-editor-with-revamped-bpqa.templates.troubleshooting-article-description',
		defaultMessage: 'Guide users to resolve issues',
		description:
			'Description for troubleshooting article template to explain what the template consist of',
	},
});
